import useFilterHook from "~/utils/use-filtering"
import { compact } from '~/utils/helpers'

const usePlpProductsHook = ({ 
  collection, plpHook, setProducts, setUngroups
}) => {

  const { upd_prods, filter_stores } = useFilterHook()

  const isBlock = (obj) => {
    return obj.hasOwnProperty('blocks') && obj.blocks && obj.blocks.length > 0
  }

  const buildProducts = (props) => {
    const nofilts = (props.filters.length < 1 && !props.currGrpId && !props.currSort)

    if (nofilts) {
      let initprods = collection.initProducts
      if (props.featIds?.length > 0) {
        initprods = findFeatprod(initprods, props.featIds, collection.prods_pk)
      }
      setProducts(initprods)
      setUngroups(collection.initUngroups)
      return
    }

    let new_prods
    new_prods = onfilterProducts(props)
    new_prods = {products: compact(new_prods)}

    if (!!new_prods.products.find(x => x.hasOwnProperty('products'))) {
      new_prods.products = new_prods.products.filter(x => x.products.length > 0)
    }
    new_prods.products = checkSplit(new_prods.products, props.filters)
    setProducts(new_prods.products)
    if (new_prods?.ungroups) setUngroups(new_prods.ungroups)
  }

  const onfilterProducts = (props) => {
    const { 
      products, allColors, filters, locate, 
      currGrpId, currGroup, currSort, featIds
    } = props

    const allProducts = collection.products
    const subnav = collection.subnav
    const { shw_singpl } = collection.rules || {}
    const singPlTiles = shw_singpl || false
    const storeGendConflct = plpHook.checkStoreGend({locate})
    const plpInv = false

    const { groups, handle, gender } = collection

    if (!products) return []

    const new_props = {
      ...props,
      products: products.flat(),
      allProducts: allProducts
    }

    const getGroupName = (id) => {
      if (!id) return false
      let group_name = id ? groups.find(x => x.mid === id) : false
      if (group_name) group_name = group_name.data.name
      return group_name
    }
      
    let is_filters = filters.length > 0 || locate?.currStores.length > 0
    let group_name = getGroupName(currGrpId)
    let group_obj = false

    if (currGrpId && !is_filters) {
      group_obj = groups.find(x => x.mid === currGrpId)
      group_obj = JSON.parse(JSON.stringify(group_obj))
    }

    if (group_obj && !group_obj.hasOwnProperty('products')) {
      let setgroups = setupGroupProds({currGroup, allProducts, filters})
      group_obj.products = setgroups.find(x => x.mid === currGrpId)?.products || []
    }

    const prod_set = group_obj ? JSON.parse(JSON.stringify(group_obj.products)) : is_filters ? allProducts : new_props.products

    const collobj = {
      products: prod_set,
      group: currGroup,
      currGrpName: group_name, 
      filters: filters, 
      currSort: currSort,
      subnav: !!subnav, 
      isAllColl: handle === 'all' || handle.includes('-all'),
      plpInv: plpInv,
      gender: gender
    }
    if (group_obj) {
      group_obj.products = filter_stores(group_obj.products,false, gender)
      new_props.products = upd_prods(group_obj.products, collobj)
      if (!allColors) new_props.products = checkSingle(new_props)
      group_obj.products = new_props.products
      // group_obj = filter_stores(group_obj,false, gender)

      return [group_obj]
    }

    new_props.products = upd_prods(products, collobj)
    new_props.products = checkSingle(new_props)
    new_props.products = new_props.products.filter(x => x !== null)
    if (is_filters) new_props.products = new_props.products.filter(x => !isBlock(x) && x.pl_pima !== 99998)
    if (!is_filters && featIds) new_props.products = findFeatprod(new_props.products, featIds, collection.prods_pk)
    
    return new_props.products
  }

  const checkSingle = (props) => {
    const { products, filters } = props
    const { product_lines, handle } = collection
    const { shw_singpl } = collection.rules || {}
    const singPlTiles = shw_singpl || false

    if (!singPlTiles) return products
    if (filters.length > 0) return products

    const is_grouped = products.find(x => x?.hasOwnProperty('products'))
    // deep clone this
    let new_shown = JSON.parse(JSON.stringify(products)).filter(x => !!x)

    let pl_ids
    let alt_pls = product_lines.filter(x => !!x &&x.is_alt)
    alt_pls = alt_pls.map(x => x.pima_id)
    if (handle.includes('short-and-tall')) {
      alt_pls = []
    }

    if (!is_grouped) {
      // pl_ids = [...new Set( new_shown.map(x => x.pl_pima) )]
      // pl_ids = pl_ids.filter(x => !alt_pls.includes(x))
      // new_shown = pl_ids.map(id => new_shown.find(x => x.pl_pima === id))

      let pls_used = []
      new_shown = new_shown.filter(x => {
        if (alt_pls.includes(x.pl_pima)) return false
        if (x.pl_pima === 99998) return x 
        if (!pls_used.includes(x.pl_pima)) {
          pls_used.push(x.pl_pima)
          return x
        }
        return false
      })
    } else {
      new_shown = new_shown.map(grp => {
        pl_ids = [...new Set( grp.products.map(x => x.pl_pima) )]
        pl_ids = pl_ids.filter(x => !alt_pls.includes(x))
        grp.products = pl_ids.map(id => grp.products.find(x => x.pl_pima === id))
        return grp
      })
    }
    return new_shown
  }


  const setupGroupProds = ({currGroup, allProducts, filters}) => {
    const { handle, groups, prods_grouped, prods_pk } = collection

    const is_all = handle === 'all' || handle.includes('-all')

    if (is_all) return groups

    const group_name = currGroup.includes('group') ? currGroup : `group${currGroup}`
    let group_objs = groups.filter(x => x.type === group_name)
    
    for (const item of group_objs) {
      let grp_prods = prods_grouped.find(x => x.mid === item.mid)
      if (!grp_prods || !grp_prods.hasOwnProperty('products')) continue
      grp_prods = grp_prods.products.map(prod_id => {
        const found_prod = allProducts.find(x => x.mid === prod_id)
        const found_pk = prods_pk.find(x => x.mid === prod_id)
        if (found_pk) found_pk['pl_pima'] = 99998
        return found_prod || found_pk
      })
      grp_prods = grp_prods.filter(x => !!x)
      const show_length = filters.length > 0 && filters.find(x => x.type === 'length' || x.type === 'inseam')
      if (!show_length) grp_prods = grp_prods.filter(x => !!x && !x.is_alt_cut)
      item.products = grp_prods
    }

    group_objs = group_objs.filter(x => x.hasOwnProperty('products') && !x.products.length < 1)

    return group_objs
  }

  const checkUngroups = ({singPlTiles, filters, currGroup}) => {
    const { grp_default } = collection

    const check_test = (typeof sessionStorage !== 'undefined') && sessionStorage.getItem('grptest') === 'true'
    if (!singPlTiles && check_test) return []

    const ungroups = getUngroups({currGroup})
    const show = grp_default && !filters.length && ungroups && ungroups?.length > 0
    return show ? ungroups : []
  }

  const getUngroups = ({currGroup}) => {
    const { products, ungrouped } = collection

    if (!ungrouped || !ungrouped[currGroup]) return false
    const cprods = compact(products).filter(x => x.hasOwnProperty('mid'))
    
    let new_ungrouped = compact(ungrouped[currGroup]).map(id => cprods?.find(x => x?.mid === id))

    return compact(new_ungrouped)
  }

  const checkSplit = (products, filters=[]) => {
    if (filters.length > 0 || !products) return [products]

    let checked_products = structuredClone(compact(products))
    checked_products = checked_products.reduce((acc, obj) => {
      if (isBlock(obj)) {
        acc.push(obj)
        acc.push([])
      } else {
        acc[acc.length - 1].push(obj)
      }
      return acc
    }, [[]])

    checked_products = checked_products.filter(x => isBlock(x) || x.length > 0)
    return checked_products
  }
  
  const findFeatprod = (products, featIds) => {
    const is_grouped = !!products.flat().find(x => x?.hasOwnProperty('products'))

    let new_prods = compact(products.flat())
    let feat_prods
    let feat_group = []
    if (!is_grouped) {
      feat_prods = featIds.map(id => {
        let prod = new_prods.find(x => x?.mid === id)
        if (!prod) collection.prods_pk.find(x => x?.mid === id)
        return prod
      })
      feat_prods = compact(feat_prods)
    } else {
      feat_group = new_prods.find(grp => compact(grp.products).find(x => featIds.includes(x?.mid)) )
      if (feat_group) feat_prods = featIds.map(id => compact(feat_group.products).find(x => x?.mid === id) )
    }

    if (!feat_prods) return products
    
    if (!is_grouped) {
      new_prods = new_prods.filter(x => !featIds.includes(x?.mid))
      new_prods = feat_prods.concat(new_prods)
      return [new_prods]
    }
      
    new_prods = new_prods.filter(x => x?.mid !== feat_group.mid)
    feat_group.products = compact(feat_group.products).filter(x => !featIds.includes(x?.mid))
    feat_group.products = feat_prods.concat(feat_group.products)
    new_prods.unshift(feat_group)

    return [new_prods]
  }

  const getInv = () => {
    
  }

  return { buildProducts, getInv }
}


export default usePlpProductsHook

